/**
 * Persistent hazard-tape ticker. Plain warm copy — calls out demo data
 * and the onboarding inbox so prospective customers always see how to reach us.
 */
const CONTACT = 'site-inspection-app@prashamhtrivedi.in'

const NOTICE_ITEMS = [
  'This is a demo',
  'Sample data only — not real projects',
  'Want it for your sites?',
  `Email us — ${CONTACT}`,
] as const

const REPEATS = 3

export function DemoNotice() {
  const items = Array.from({ length: REPEATS }).flatMap(() => NOTICE_ITEMS)
  return (
    <div className="relative w-full bg-surface-950 border-b-2 border-accent-500 overflow-hidden">
      <div className="flex items-stretch">
        <div className="hazard-tape-thin px-4 py-2 flex items-center gap-2 shrink-0 z-10">
          <span className="font-sans text-[11px] font-bold tracking-wide text-surface-950 bg-accent-500 px-2.5 py-1">
            Notice
          </span>
        </div>
        <div className="relative flex-1 overflow-hidden">
          <div className="marquee-track flex whitespace-nowrap py-2.5">
            {[...items, ...items].map((label, i) => (
              <span key={i} className="px-6 inline-flex items-center gap-3 shrink-0">
                {label.includes(CONTACT) ? (
                  <a
                    href={`mailto:${CONTACT}?subject=Onboard%20our%20crew%20to%20Site%20Inspection`}
                    className="text-accent-400 underline decoration-accent-500/40 underline-offset-4 hover:text-surface-50 transition text-[13px]"
                  >
                    {label}
                  </a>
                ) : (
                  <span className="text-[13px] text-surface-100">{label}</span>
                )}
                <span aria-hidden className="text-surface-700 ml-3">◆</span>
              </span>
            ))}
          </div>
        </div>
        <div className="hazard-tape-thin w-12 shrink-0" aria-hidden />
      </div>
    </div>
  )
}
